import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useAuth} from "../context/AuthContext";
import {Link, NavLink, useNavigate} from "react-router-dom";

const Header = () => {
    const {currentUser, logout} = useAuth()
    const [error, setError] = useState()
    const [active, setActive] = useState(1)
    const navigate = useNavigate()

    const handlelogout = async (e) => {
        e.preventDefault()
        setError('')
        try {
            await logout()
            navigate('/signin')
        } catch (e) {
            console.log(e)
            setError('Dasturni yopish oynasida xatolik bor!')
        }
    }

    const activeHandler = (number) => {
        setActive()
        setActive(number)
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary sticky-top">
            <div className="container">
                <NavLink to="/" className="navbar-brand">MWR</NavLink>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink className="nav-link"  aria-current="page" to="/aqlli-suv">Aqlli-suv</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link"  to="/dayver">Dayver</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link"  to="/nasos">Nasos</NavLink>
                        </li>
                    </ul>
                    <form className="d-flex" onSubmit={handlelogout}>
                        <span className="navbar-text pe-3 d-none d-lg-block">
                          <FontAwesomeIcon icon="fa-solid fa-envelope" /> {currentUser && currentUser.email}
                        </span>
                        <button type="submit" className="btn btn-light text-danger btn-logout"><FontAwesomeIcon icon="fa-solid fa-right-from-bracket" /> Chiqish</button>
                    </form>
                </div>

            </div>
        </nav>
    );
};

export default Header;